<template>
  <SelectApi :endpoint="`rma/orderLines/${salesOrderNo}`" :itemTitle="title">
    <template #item="{ item }">
      <VListItem v-bind="item.props" :title="title(item.item.raw)" :subtitle="variant(item.item.raw)" />
    </template>
    <template #selection="{ item }">
      {{ title(item.item.raw) }}
    </template>
  </SelectApi>
</template>

<script>
export default {
  name: 'SelectRMAOrderLine',
  props: {
    salesOrderNo: {
      required: true
    }
  },
  methods: {
    title(opt) {
      // console.log('SalesOrderLinesSelect: ', opt);
      return `${opt.article.name} (${opt.article.part_number})`;
    },

    variant(opt) {
      return `${opt.Variant_Code} - ${opt.Quantity} PCS`;
    }
  }
};
</script>
